import { Avatar } from "antd";
;
import { Card, CardBody, CardHeader } from "reactstrap";
import NoImg from "../../../assets/images/No_image_available.png"
import { useTranslation } from "react-i18next";

const VehIncident = ({ vehicle, user }) => {
  const fileName = vehicle?.fileName;
  const imageUrl = `${process.env.REACT_APP_API_MEDIA_URL}/print/${fileName}`;
const { t } = useTranslation();
const getStatusColor = (statut) => {
  switch (statut) {
    case "En service":
    case "En service #2FB550":
    case "Actif #2FB550":
      return "#2FB550";
    case "Hors service":
      return " #FF2D55";
    default:
      return " #FF9500";
  }
};
  return (
    <Card className="text-light">
      <CardHeader className="text-light">
        <div className="insp-section-title">
         {t("incident_detail.informationVehicle")}
        </div >
      </CardHeader>
      <CardBody className="d-flex-align-items-center text-light">
        <div className="text-light insp-d-flex-align-items-center">
          <Avatar className="insp-small-avatarVehicle">
            <img src={imageUrl || NoImg} alt="" />
          </Avatar>
          <table className="table table-bacground ">
          <tbody>
              <tr className="title-th">
                <td>{t("incident_detail.faitPar")}</td>
                <td>{t("incident_detail.numberPhone")}</td>
                <td>{t("incident_detail.nameVehicle")}</td>
                <td>{t("incident_detail.status")}</td>
                <td>{t("incident_detail.realiserBy")}</td>
                <td>{t("incident_detail.numberMatriculation")}</td>
              </tr>

              <tr className="title-td">
                <td>{user?.name || "-"}</td>
                <td>{user?.phone || "-"}</td>
                <td>{vehicle?.brand || "-"}</td>
                <td className=" d-flex align-items-center">
                  <span className="statut"style={{backgroundColor: getStatusColor(vehicle?.statut),}}>
                    </span>
                     {vehicle?.statut || "-"}</td>
                     <td>{vehicle?.createdAt ? new Date(vehicle.createdAt).toLocaleDateString('fr-FR') : "-"}</td>
                <td>{vehicle?.registrationNumber || "-"}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </CardBody>
    </Card>
  );
};

export default VehIncident;
